import { useEffect, useRef } from 'react';
export var useEffectWithoutInitCall = function useEffectWithoutInitCall(effect, deps) {
  var isInitialRenderRef = useRef(true);
  useEffect(function () {
    if (isInitialRenderRef.current) {
      isInitialRenderRef.current = false;
    } else {
      effect();
    }
  }, deps);
};